import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalUseField } from '../models/LocalUseField.model';
import { LocalUseResponse } from '../models/LocalUseResponse.model';

@Injectable()
export class LocalUseService {
	endpoint = '/api/localuse';

	constructor(private readonly http: HttpClient) {}

	getEntityFields(entityType: string): Observable<LocalUseResponse> {
		return this.http
			.get(`${this.endpoint}/entity-fields`, {
				params: { entityType },
			})
			.pipe(map((response) => new LocalUseResponse(response)));
	}

	getEntityData(entityType: string, entityId: string, groupFilter: string): Observable<LocalUseResponse> {
		return this.http
			.get(`${this.endpoint}/entity-data`, {
				params: { entityType, entityId, groupFilter },
			})
			.pipe(map((response) => new LocalUseResponse(response)));
	}

	//TODO this function is presently hosted in AJS. Update to Observable<LocalUseResponse> with API update when migrating to A11.
	postField(field: LocalUseField): Observable<any> {
		return this.http.post(this.endpoint, field);
	}

	//TODO this function is presently hosted in AJS. Update to Observable<LocalUseResponse> with API update when migrating to A11.
	deleteField(id: string): Observable<any> {
		return this.http.delete(this.endpoint, { params: { id } });
	}

	postEntityData(fields: LocalUseField[]): Observable<LocalUseResponse> {
		return this.http.post(`${this.endpoint}/entity-data`, fields).pipe(map((response) => new LocalUseResponse(response)));
	}

	deleteEntityData(id: string): Observable<LocalUseResponse> {
		return this.http
			.delete(`${this.endpoint}/entity-data`, {
				params: { id },
			})
			.pipe(map((response) => new LocalUseResponse(response)));
	}
}
